import { ApiResponse } from 'apisauce';
import { restApi } from '../../../../../services/api';
import { PaginatedResponse } from '../../../../../types/request.types';
import { cancelTokenFromSignal } from '../../../../../utils/axios.utils';

const toPaginatedResponse = <T>(data?: PaginatedResponse<T> | T[] | null): PaginatedResponse<T> =>
  Array.isArray(data)
    ? { data, count: data.length }
    : { data: data?.data ?? [], count: data?.count ?? 0 };

export const makeFindAsyncAutocompleteOptions =
  <T>(url: string) =>
  async (
    params?: Record<string, unknown>,
    signal?: AbortSignal,
  ): Promise<ApiResponse<PaginatedResponse<T>>> => {
    const response = await restApi.get<PaginatedResponse<T> | T[]>(url, params, {
      cancelToken: cancelTokenFromSignal(signal)?.token,
    });

    if (!response.ok) {
      return response as ApiResponse<PaginatedResponse<T>>;
    }

    return { ...response, data: toPaginatedResponse<T>(response.data) };
  };

interface FindByIdsParams {
  url: string;
  ids: string[];
  idsAlias: string;
  limit: number;
}

export const findAsyncAutocompleteOptionsByIds = <T>({
  url,
  ids,
  idsAlias,
  limit,
}: FindByIdsParams) => {
  const search = new URLSearchParams();
  ids.forEach((id) => search.append(idsAlias, id));
  search.append('limit', String(limit));
  return restApi.get<PaginatedResponse<T> | T[]>(`${url}?${search.toString()}`);
};
